import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Bag, BrokenBag } from "../../assets";

interface MessageProps {
  type: "empty" | "error";
}

const Message: FC<MessageProps> = ({ type }) => {
  const { t } = useTranslation("message");

  const data = {
    empty: {
      icon: Bag,
      alt: t("empty.alt"),
      title: t("empty.title"),
      text: t("empty.text"),
    },
    error: {
      icon: BrokenBag,
      alt: t("error.alt"),
      title: t("error.title"),
      text: t("error.text"),
    },
  };

  return (
    <div className="my-transactions__message">
      <div className="my-transactions__message-img">
        <img src={data[type].icon} alt={data[type].alt} />
      </div>

      <div className="my-transactions__message-texts">
        <h3 className="my-transactions__message-title">{data[type].title}</h3>
        <p className="my-transactions__message-text">{data[type].text}</p>
      </div>
    </div>
  );
};

export default Message;
